import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39f35366"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hotspot-hero" }


import { Image as VanImage } from "vant";


export default /*#__PURE__*/_defineComponent({
  __name: 'Hero',
  props: {
    image: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.image)
      ? (_openBlock(), _createBlock(_unref(VanImage), {
          key: 0,
          fit: "cover",
          class: "hotspot-hero__image",
          src: __props.image,
          alt: ""
        }, null, 8, ["src"]))
      : _createCommentVNode("", true)
  ]))
}
}

})